export default __webpack_public_path__ + "static/media/learn-to-drive-a-manual-1597958687.db96de30.jpg";